
export interface DataParameter {
    name: string,
    value: string,
    type: number;
    source: string;
}

export interface DataResult {
    returnType: string,
    returnValue: string;
    returnValueName: string;
}

export interface DataQuery {
    id: string,
    name: string,
    collection: string,
    database: DatabaseType,
    parameters: DataParameter[],
    resultValues: DataResult[],
    queryText: string;
    where: WhereClause[];
}

export enum DatabaseType {
    Simple = "simple",
    Table = "table",
    Document = "document",
    Context = "context"
}

export enum TableFilterType {
    AndFilter = "and",
    BinaryFilter = "binary",
    EqualFilter = "equal",
    GreaterThanFilter = "greaterThan",
    GreaterThanOrEqualFilter = "greaterThanOrEqual",
    LessThanFilter = "lessThan",
    LessThanOrEqualFilter = "lessThanOrEqual",
    NotEqualFilter = "notEqual",
    NotFilter = "not",
    OrFilter = "or",
    PartitionKeyEqualFilter = "partitionKeyEqual",
    PropertyKeyEqualFilter = "propertyKeyEqual",
    PropertyEqualFilter = "propertyEqual",
    PropertyFilter = "property",
    PropertyGreaterThanFilter = "propertyGreaterThan",
    PropertyGreaterThanOrEqualFilter = "propertyGreaterThanOrEqual",
    PropertyLessThanFilter = "propertyLessThan",
    PropertyLessThanOrEqualFilter = "propertyLessThanOrEqual",
    PropertyNotEqualFilter = "propertyNotEqual",
    RowKeyEqualFilter = "rowKeyEqual",
    ValueFilter = "value"
}

export interface WhereClause {
    leftFilter: any;
    operand: string;
    rightFilter: any;
}

export function queryResultsHaveChanged(configuredQuery: DataQuery, currentQuery: DataQuery): boolean {
    if (configuredQuery.resultValues.length !== currentQuery.resultValues.length) {
        return true;
    }
    let foundResult = 0;
    for (let r = 0; r < currentQuery.resultValues.length; r++) {
        const rv = currentQuery.resultValues[r];
        const index = configuredQuery.resultValues.findIndex(fi => fi.returnValue === rv.returnValue);
        if (index === -1) {
            return false;
        } else {
            foundResult = foundResult + 1;
        }
    }
    return foundResult !== configuredQuery.resultValues.length;
}